exports.onClientEntry = () => {
  if (!('fetch' in window)) {
    require('whatwg-fetch'); //eslint-disable-line
  }
};
